import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "min-h-0 flex-1 flex flex-col overflow-y-auto" }
const _hoisted_2 = { class: "flex flex-shrink-0 items-center justify-between border-b px-6 h-16" }
const _hoisted_3 = {
  id: "slide-over-title",
  class: "text-lg font-bold text-gray-900"
}
const _hoisted_4 = { class: "ml-3 h-7 flex items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Close", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "relative flex-grow" }
const _hoisted_8 = { class: "h-full bg-gray-100 p-6" }
const _hoisted_9 = { class: "flex-shrink-0 px-4 py-4 flex justify-end border-t" }
const _hoisted_10 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.schema.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
          }, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema.fields, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.name,
              class: "mb-4 p-4",
              style: {"border-bottom":"2px solid white"}
            }, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(field.component), _mergeProps({
                modelValue: _ctx.formValues[field.name],
                "onUpdate:modelValue": ($event: any) => ((_ctx.formValues[field.name]) = $event)
              }, field, {
                error: _ctx.formErrors[field.name],
                onChange: ($event: any) => (_ctx.validateField(field.name)),
                onInput: ($event: any) => (_ctx.validateField(field.name)),
                onBlur: ($event: any) => (_ctx.validateField(field.name)),
                onContactAdd: _ctx.contactAdd
              }), null, 16, ["modelValue", "onUpdate:modelValue", "error", "onChange", "onInput", "onBlur", "onContactAdd"]))
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        type: "button",
        class: "bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "submit",
        class: _normalizeClass(["ml-4 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-brand", !_ctx.formValid ? 'opacity-25' : '']),
        disabled: !_ctx.formValid,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSubmit()))
      }, _toDisplayString(_ctx.schema.submitText), 11, _hoisted_10)
    ])
  ], 64))
}